export default class RedMatOptionsDTO {
  larmorFrequency: number;

  correlationTime: number;

  cutoffDistance: number;

  ligandConcentration: number;

  receptorConcentration: number;

  dissociationConstant: number;

  constructor() {
    this.larmorFrequency = 500;
    this.correlationTime = 50;
    this.cutoffDistance = 10;
    this.ligandConcentration = 1000;
    this.receptorConcentration = 50;
    this.dissociationConstant = 500;
  }
}
